export const pricing = {
  title: 'Prezzi e flessibilità',
  mainOffer: {
    headline: 'Sedute a €98 per la terapia individuale, €148 per la terapia di coppia: investire nel tuo benessere con trasparenza',
    offers: [
      {
        type: 'individual',
        price: 98,
        currency: 'EUR',
        unit: 'seduta'
      },
      {
        type: 'couple',
        price: 148,
        currency: 'EUR',
        unit: 'seduta'
      }
    ]
  },
  features: [
    {
      title: 'Doppia specializzazione in psicoterapia cognitivo-comportamentale e sessuologia clinica',
      description: 'Un percorso terapeutico che beneficia di due competenze specialistiche complementari offre una visione più completa della persona. La combinazione tra psicoterapia cognitivo-comportamentale e sessuologia clinica permette di affrontare non solo i sintomi psicologici, ma anche gli aspetti relazionali e sessuali che spesso sono interconnessi con il benessere generale.'
    },
    {
      title: 'Supervisione ed intervisione clinica continua per garantire i massimi standard',
      description: 'La supervisione è un processo professionale in cui il terapeuta si confronta regolarmente con colleghi esperti per analizzare i casi clinici, perfezionare le tecniche terapeutiche e garantire la qualità del trattamento. Questo significa che ogni seduta beneficia non solo della mia esperienza diretta, ma anche del supporto e della competenza di un team di professionisti, assicurando ai pazienti il massimo livello di cura possibile.'
    },
    { title: 'Studio situato in area di prestigio nel centro di Milano', 
      description: 'Un ambiente professionale e riservato che favorisce il processo terapeutico in una location facilmente raggiungibile.'
    },
    {title: 'Sessioni disponibili sia in studio nel centro di Milano che online'},
    {title: 'Massima flessibilità di orari per adattarsi ai tuoi impegni'},
    {title: 'Prima seduta conoscitiva gratuita per valutare insieme il percorso più adatto a te'}
  ],
  cta: {
    text: 'Inizia il tuo cambiamento',
    action: 'start-change'
  },
  metadata: {
    section: 'pricing',
    currency: 'EUR',
    paymentMethods: ['cash', 'bank-transfer'],
    languages: ['italian', 'english']
  }
};
